// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file marketing_campaign_manager_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyRequestSchema, EmptyResponseSchema } from "./empty_pb";
import { file_empty } from "./empty_pb";
import type { MarketingCampaign, MarketingCampaign_AudienceStats } from "./marketing_campaign_pb";
import { file_marketing_campaign } from "./marketing_campaign_pb";
import type { MarketingCampaignSettings } from "./marketing_campaign_settings_pb";
import { file_marketing_campaign_settings } from "./marketing_campaign_settings_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file marketing_campaign_manager_service.proto.
 */
export const file_marketing_campaign_manager_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_empty, file_marketing_campaign, file_marketing_campaign_settings]);

/**
 * @generated from message grpc.api.v1.MarketingCampaignIdRequest
 */
export type MarketingCampaignIdRequest = Message<"grpc.api.v1.MarketingCampaignIdRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignIdRequest.
 * Use `create(MarketingCampaignIdRequestSchema)` to create a new message.
 */
export const MarketingCampaignIdRequestSchema: GenMessage<MarketingCampaignIdRequest> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 0);

/**
 * @generated from message grpc.api.v1.MarketingCampaignRequest
 */
export type MarketingCampaignRequest = Message<"grpc.api.v1.MarketingCampaignRequest"> & {
  /**
   * @generated from field: grpc.api.v1.MarketingCampaign marketing_campaign = 1;
   */
  marketingCampaign?: MarketingCampaign | undefined;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignRequest.
 * Use `create(MarketingCampaignRequestSchema)` to create a new message.
 */
export const MarketingCampaignRequestSchema: GenMessage<MarketingCampaignRequest> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 1);

/**
 * @generated from message grpc.api.v1.MarketingCampaignTestRequest
 */
export type MarketingCampaignTestRequest = Message<"grpc.api.v1.MarketingCampaignTestRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: repeated string recipients = 2;
   */
  recipients: string[];
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignTestRequest.
 * Use `create(MarketingCampaignTestRequestSchema)` to create a new message.
 */
export const MarketingCampaignTestRequestSchema: GenMessage<MarketingCampaignTestRequest> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 2);

/**
 * @generated from message grpc.api.v1.MarketingCampaignArchiveRequest
 */
export type MarketingCampaignArchiveRequest = Message<"grpc.api.v1.MarketingCampaignArchiveRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool is_achived = 2;
   */
  isAchived: boolean;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignArchiveRequest.
 * Use `create(MarketingCampaignArchiveRequestSchema)` to create a new message.
 */
export const MarketingCampaignArchiveRequestSchema: GenMessage<MarketingCampaignArchiveRequest> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 3);

/**
 * @generated from message grpc.api.v1.MarketingCampaignSendRequest
 */
export type MarketingCampaignSendRequest = Message<"grpc.api.v1.MarketingCampaignSendRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool omit_campaign_check = 2;
   */
  omitCampaignCheck: boolean;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignSendRequest.
 * Use `create(MarketingCampaignSendRequestSchema)` to create a new message.
 */
export const MarketingCampaignSendRequestSchema: GenMessage<MarketingCampaignSendRequest> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 4);

/**
 * @generated from message grpc.api.v1.MarketingCampaignResponse
 */
export type MarketingCampaignResponse = Message<"grpc.api.v1.MarketingCampaignResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MarketingCampaign marketing_campaign = 1;
   */
  marketingCampaign?: MarketingCampaign | undefined;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignResponse.
 * Use `create(MarketingCampaignResponseSchema)` to create a new message.
 */
export const MarketingCampaignResponseSchema: GenMessage<MarketingCampaignResponse> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 5);

/**
 * @generated from message grpc.api.v1.ListCampaignsRequestParams
 */
export type ListCampaignsRequestParams = Message<"grpc.api.v1.ListCampaignsRequestParams"> & {
  /**
   * @generated from field: int32 begin_date = 1;
   */
  beginDate: number;

  /**
   * @generated from field: int32 end_date = 2;
   */
  endDate: number;

  /**
   * @generated from field: bool show_archived = 3;
   */
  showArchived: boolean;
};

/**
 * Describes the message grpc.api.v1.ListCampaignsRequestParams.
 * Use `create(ListCampaignsRequestParamsSchema)` to create a new message.
 */
export const ListCampaignsRequestParamsSchema: GenMessage<ListCampaignsRequestParams> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 6);

/**
 * @generated from message grpc.api.v1.ListCampaignsRequest
 */
export type ListCampaignsRequest = Message<"grpc.api.v1.ListCampaignsRequest"> & {
  /**
   * @generated from field: grpc.api.v1.ListCampaignsRequestParams params = 1;
   */
  params?: ListCampaignsRequestParams | undefined;
};

/**
 * Describes the message grpc.api.v1.ListCampaignsRequest.
 * Use `create(ListCampaignsRequestSchema)` to create a new message.
 */
export const ListCampaignsRequestSchema: GenMessage<ListCampaignsRequest> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 7);

/**
 * @generated from message grpc.api.v1.MarketingCampaignPreviewContactFilterRequest
 */
export type MarketingCampaignPreviewContactFilterRequest = Message<"grpc.api.v1.MarketingCampaignPreviewContactFilterRequest"> & {
  /**
   * @generated from field: string contact_filter_data = 1;
   */
  contactFilterData: string;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignPreviewContactFilterRequest.
 * Use `create(MarketingCampaignPreviewContactFilterRequestSchema)` to create a new message.
 */
export const MarketingCampaignPreviewContactFilterRequestSchema: GenMessage<MarketingCampaignPreviewContactFilterRequest> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 8);

/**
 * @generated from message grpc.api.v1.MarketingCampaignPreviewContactFilterResponse
 */
export type MarketingCampaignPreviewContactFilterResponse = Message<"grpc.api.v1.MarketingCampaignPreviewContactFilterResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MarketingCampaign.AudienceStats audience_stats = 1;
   */
  audienceStats?: MarketingCampaign_AudienceStats | undefined;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignPreviewContactFilterResponse.
 * Use `create(MarketingCampaignPreviewContactFilterResponseSchema)` to create a new message.
 */
export const MarketingCampaignPreviewContactFilterResponseSchema: GenMessage<MarketingCampaignPreviewContactFilterResponse> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 9);

/**
 * @generated from message grpc.api.v1.MarketingCampaignSettingsResponse
 */
export type MarketingCampaignSettingsResponse = Message<"grpc.api.v1.MarketingCampaignSettingsResponse"> & {
  /**
   * @generated from field: grpc.api.v1.MarketingCampaignSettings settings = 1;
   */
  settings?: MarketingCampaignSettings | undefined;
};

/**
 * Describes the message grpc.api.v1.MarketingCampaignSettingsResponse.
 * Use `create(MarketingCampaignSettingsResponseSchema)` to create a new message.
 */
export const MarketingCampaignSettingsResponseSchema: GenMessage<MarketingCampaignSettingsResponse> = /*@__PURE__*/
  messageDesc(file_marketing_campaign_manager_service, 10);

/**
 * @generated from service grpc.api.v1.MarketingCampaignManagerService
 */
export const MarketingCampaignManagerService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.getCampaign
   */
  getCampaign: {
    methodKind: "unary";
    input: typeof MarketingCampaignIdRequestSchema;
    output: typeof MarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.createCampaign
   */
  createCampaign: {
    methodKind: "unary";
    input: typeof MarketingCampaignRequestSchema;
    output: typeof MarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.updateCampaign
   */
  updateCampaign: {
    methodKind: "unary";
    input: typeof MarketingCampaignRequestSchema;
    output: typeof MarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.deleteCampaign
   */
  deleteCampaign: {
    methodKind: "unary";
    input: typeof MarketingCampaignIdRequestSchema;
    output: typeof MarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.listCampaigns
   */
  listCampaigns: {
    methodKind: "server_streaming";
    input: typeof ListCampaignsRequestSchema;
    output: typeof MarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.sendCampaign
   */
  sendCampaign: {
    methodKind: "unary";
    input: typeof MarketingCampaignSendRequestSchema;
    output: typeof MarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.archiveCampaign
   */
  archiveCampaign: {
    methodKind: "unary";
    input: typeof MarketingCampaignArchiveRequestSchema;
    output: typeof MarketingCampaignResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.previewContactFilter
   */
  previewContactFilter: {
    methodKind: "unary";
    input: typeof MarketingCampaignPreviewContactFilterRequestSchema;
    output: typeof MarketingCampaignPreviewContactFilterResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.testCampaign
   */
  testCampaign: {
    methodKind: "unary";
    input: typeof MarketingCampaignTestRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.MarketingCampaignManagerService.getSettings
   */
  getSettings: {
    methodKind: "unary";
    input: typeof EmptyRequestSchema;
    output: typeof MarketingCampaignSettingsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_marketing_campaign_manager_service, 0);

